<template>
  <div class="roles-tab">
    <Button
      v-if="showEditRolesButton"
      buttonColor="darkBlue"
      buttonSize="big"
      buttonText="Добавить роль"
      @click="showRolePopup"
      class="roles-tab__button"
    />
    <SubpanelTable
      :tableColumns="tableColumns"
      :tableData="tableData"
      :height="tableHeight"
      :allowDelete="allowDelete"
      @handleDelete="role => deleteRole(role)"
    />
  </div>
</template>

<script>
import { eventBus } from '@/bus';
import { store } from '@/store';
import { EVENTBUS_EVENTS, MODULE } from '@/utils/constants';
import { errorMsg, mixin } from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import SubpanelTable from 'Elements/Table/SubpanelTable';

export default {
  mixins: [mixin, errorMsg],
  created() {
    eventBus.$on(EVENTBUS_EVENTS.ROLES_EDIT, success =>
      this.handleEditRolesEvent(success)
    );
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.ROLES_EDIT);
  },
  computed: {
    tableData() {
      return (
        store.state.subpanels.activeSubpanelData?.user_roles?.data?.List || []
      );
    },
    showEditRolesButton() {
      return store.state.users.userMetadata?.bean?.isRoleAddAllowed || false;
    },
    allowDelete() {
      return (
        !store.state.subpanels.activeSubpanelData.user_roles.data?.title.delete
          .hidden || false
      );
    },
    tableColumns() {
      const columns = store.state.subpanels.activeSubpanelData?.user_roles?.data
        ?.title
        ? {
            ...store.state.subpanels.activeSubpanelData?.user_roles?.data?.title
          }
        : {};
      if (columns.hasOwnProperty('delete')) {
        delete columns.delete;
      }
      return columns || {};
    },
    tableHeight() {
      return (
        49 +
        store.state.subpanels.activeSubpanelData?.user_roles?.data?.List
          .length *
          51
      ).toString();
    }
  },
  methods: {
    handleEditRolesEvent(success) {
      if (success) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Роли успешно изменены',
          duration: 15000,
          type: 'success'
        });
        eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'user_roles');
      } else {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Возникла ошибка при изменении ролей пользователя',
          duration: 15000,
          type: 'error'
        });
      }
    },
    showRolePopup() {
      const intent = {
        module: MODULE.USERS,
        action: 'getRolePopup',
        intentArea: 'CustomPopup',
        intentType: 'create_popup',
        request: {
          url: '/index.php?module=Users&action=getRolePopup',
          request_params: {
            record: this.$route?.params?.id
          }
        }
      };
      store.dispatch('dialog/getPopupData', { item: { intents: [intent] } });
    },
    async deleteRole(role) {
      try {
        const response = await mixin.methods.sendFormRequestFromIntent(
          role.delete.intent
        );
        if (response.data.status === 'error') {
          this.showNotification({
            offset: 100,
            showClose: true,
            message: response.data.error.error_text,
            duration: 15000,
            type: 'error'
          });
          return;
        }
        eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, 'user_roles');
      } catch (e) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Возникла ошибка при удалении роли пользователя',
          duration: 15000,
          type: 'error'
        });
      }
    }
  },
  components: {
    Button,
    SubpanelTable
  }
};
</script>

<style lang="scss" scoped>
.roles-tab {
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px;
  gap: 16px;

  &__button {
    width: fit-content;
  }
}
</style>
